export default "__VITE_ASSET__6a9b4004__"